import React from 'react';

//Utility Packages
import { Dialog } from 'primereact/dialog';

const ViewJobDescription = ({ header, visible, description, onHide }) => {
  return (
    <Dialog header={header} className="person-details-popup" visible={visible} onHide={onHide}>
      <div className="m-0" dangerouslySetInnerHTML={{ __html: description }} />
    </Dialog>
  );
};

export default ViewJobDescription;
